import FavoriteIcon from "@mui/icons-material/Favorite";
import { Box, CardContent, IconButton, Stack, Typography } from "@mui/material";
import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
// import "./style.css";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { CURRENCY } from "../../../lib/variables";
import { useSnackbar } from "../../../lib/context/snackbarContext";
import { appIcons } from "../../../assets";
import Counter from "../../../components/counterButton";
import { t } from "i18next";

const deleteIconBtnStyle = {
  borderRadius: 0,
  padding: 0,
  height: 48,
  paddingX: 2,
  backgroundColor: "rgba(0, 0, 0, 0.04)",
};

const SelectedPackageProducts = ({
  language,
  product,
  index,
  selectedProducts,
  setSelectedProducts,
}) => {
  const { showSnackbar } = useSnackbar();
  const isDiscount = product?.discount > 0 ? true : false;
  const productPrice =
    product?.discount > 0 ? product?.discount : product?.price;
  const [disableCounters, setDisAbleCounters] = useState({
    add: false,
    subtract: true,
  });

  const handleIncreaseQty = (product, index) => {
    let tempCart = [...selectedProducts];

    if (product.quantity > 0) {
      if (product.selectedQty == product.quantity) {
        showSnackbar(t("maxQuantityReached"), "error");
        setDisAbleCounters({ ...disableCounters, add: true });
      } else {
        let updated = {
          ...tempCart[index],
          selectedQty: tempCart[index].selectedQty + 1,
        };
        tempCart[index] = updated;
      }
    }

    if (product.size?.length > 0) {
      if (product.selectedQty == product.selectedSize.quantity) {
        showSnackbar(t("maxQuantityReached"), "error");
        setDisAbleCounters({ ...disableCounters, add: true });
      } else {
        let updated = {
          ...tempCart[index],
          selectedQty: tempCart[index].selectedQty + 1,
        };
        tempCart[index] = updated;
      }
    }

    if (product.weigth?.length > 0) {
      if (product.selectedQty == product.selectedWeight.quantity) {
        showSnackbar(t("maxQuantityReached"), "error");
        setDisAbleCounters({ ...disableCounters, add: true });
      } else {
        let updated = {
          ...tempCart[index],
          selectedQty: tempCart[index].selectedQty + 1,
        };
        tempCart[index] = updated;
      }
    }

    if (product.color?.length > 0) {
      if (product.selectedQty == product.selectedColor.quantity) {
        showSnackbar(t("maxQuantityReached"), "error");
        setDisAbleCounters({ ...disableCounters, add: true });
      } else {
        let updated = {
          ...tempCart[index],
          selectedQty: tempCart[index].selectedQty + 1,
        };
        tempCart[index] = updated;
      }
    }

    if (product.sizeWithColor?.length > 0) {
      if (product.selectedQty == product.selectedSizeWithColor.quantity) {
        showSnackbar(t("maxQuantityReached"), "error");
        setDisAbleCounters({ ...disableCounters, add: true });
      } else {
        let updated = {
          ...tempCart[index],
          selectedQty: tempCart[index].selectedQty + 1,
        };
        tempCart[index] = updated;
      }
    }

    setSelectedProducts(tempCart);
  };

  const handleDecreaseQty = (product, ind) => {
    let tempCart = [...selectedProducts];

    if (product.selectedQty === 1) {
      showSnackbar(t("minQuantityLimit"), "error");
      setDisAbleCounters({ ...disableCounters, subtract: false });
    } else {
      let updatedProduct = {
        ...tempCart[ind],
        selectedQty: tempCart[ind].selectedQty - 1,
      };
      tempCart[ind] = updatedProduct;
      setSelectedProducts(tempCart);
    }
  };

  const handleRemoveItem = (ind) => {
    let tempCart = [...selectedProducts];
    tempCart.splice(ind, 1);
    setSelectedProducts(tempCart);
    showSnackbar(t("productRemovedFromCart"), "success");
  };

  return (
    <Box
      bgcolor={"#fff"}
      borderRadius={2}
      overflow="hidden"
      border={"1px solid #f0f0f0"}
      sx={{
        cursor: "pointer",
      }}
    >
      <Box
        height={{ xs: 170, sm: 200 }}
        position="relative"
        overflow="hidden"
        borderBottom="1px solid #f0f0f0"
      >
        <Carousel
          showArrows
          infiniteLoop
          showIndicators={false}
          showStatus={false}
          showThumbs={false}
          renderArrowPrev={(clickHandler) => (
            <IconButton
              sx={{
                padding: "4px",
                position: "absolute",
                top: "50%",
                left: 10,
                transform: "translateY(-50%)",
                backgroundColor: "white",
                boxShadow: 1,
                "&:hover": { backgroundColor: "#f5f5f5" },
              }}
              onClick={(e) => {
                e.stopPropagation();
                clickHandler();
              }}
            >
              <KeyboardArrowLeft />
            </IconButton>
          )}
          renderArrowNext={(clickHandler) => (
            <IconButton
              sx={{
                padding: "4px",
                position: "absolute",
                top: "50%",
                right: 10,
                transform: "translateY(-50%)",
                backgroundColor: "white",
                boxShadow: 1,
                "&:hover": { backgroundColor: "#f5f5f5" },
              }}
              onClick={(e) => {
                e.stopPropagation();
                clickHandler();
              }}
            >
              <KeyboardArrowRight />
            </IconButton>
          )}
        >
          {product?.images?.map((image, idx) => (
            <Box
              key={idx}
              component="img"
              src={image}
              alt={product.name[language]}
              sx={{
                height: { xs: 170, sm: 200 },
                width: "100%",
                objectFit: "contain",
                backgroundColor: "#fff",
              }}
            />
          ))}
        </Carousel>
      </Box>

      {/* Product Info */}
      <CardContent sx={{ p: 0 }}>
        <Typography
          variant="h6"
          fontWeight={500}
          textAlign="center"
          noWrap
          gutterBottom
        >
          {product?.name[language]}
        </Typography>

        {/* Price and Discount */}
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
        >
          <Typography variant="h6" fontWeight="bold">
            {CURRENCY} {productPrice}
          </Typography>
          {isDiscount && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ textDecoration: "line-through" }}
            >
              {CURRENCY} {product?.price}
            </Typography>
          )}
        </Stack>

        {/* Counter and Delete Button */}
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          mt={2}
        >
          <Counter
            value={product?.selectedQty}
            handleIncreaseQty={(e) => {
              e.stopPropagation();
              handleIncreaseQty(product, index);
            }}
            handleDecreaseQty={(e) => {
              e.stopPropagation();
              handleDecreaseQty(product, index);
            }}
          />
          <IconButton
            sx={{
              ml: 1,
              backgroundColor: "#fce4ec",
              "&:hover": { backgroundColor: "#f8bbd0" },
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveItem(index);
            }}
          >
            <img src={appIcons.deleteIcon} width={20} />
          </IconButton>
        </Stack>

        {/* Selected Options */}
        <Stack
          direction="row"
          justifyContent="center"
          spacing={1}
          mt={2}
          flexWrap="wrap"
        >
          {product?.selectedColor && (
            <Box display="flex" alignItems="center" gap={0.5}>
              <Typography variant="caption">{t("color")}:</Typography>
              <Box
                width={16}
                height={16}
                borderRadius="50%"
                bgcolor={product?.selectedColor?.color}
                border="1px solid #ccc"
              />
            </Box>
          )}
          {product?.selectedSize && (
            <Box display="flex" alignItems="center" gap={0.5}>
              <Typography variant="caption">{t("size")}:</Typography>
              <Box
                px={1}
                py={0.3}
                border="1px solid #ccc"
                borderRadius={1}
                fontSize="0.75rem"
              >
                {product?.selectedSize?.name}
              </Box>
            </Box>
          )}
          {product?.selectedWeight && (
            <Box display="flex" alignItems="center" gap={0.5}>
              <Typography variant="caption">{t("weight")}:</Typography>
              <Box
                px={1}
                py={0.3}
                border="1px solid #ccc"
                borderRadius={1}
                fontSize="0.75rem"
              >
                {product?.selectedWeight?.name}
              </Box>
            </Box>
          )}

          {product?.selectedSizeWithColor && (
            <Stack direction={"row"} alignItems={"center"} gap={1}>
              <Typography>{t("size")} :</Typography>
              <Box
                height={20}
                width={20}
                border={"1px solid"}
                borderColor={"text.borderGrey"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                borderRadius={1}
                fontSize={"0.875rem"}
              >
                {product?.selectedSizeWithColor?.size}
              </Box>
              <Typography ml={2}>{t("color")} :</Typography>

              <Box
                height={20}
                width={20}
                bgcolor={product?.selectedSizeWithColor?.color}
                borderRadius={"100%"}
              ></Box>
            </Stack>
          )}
        </Stack>
      </CardContent>
    </Box>
  );
};

export default SelectedPackageProducts;
